// import { DEFAULT_MAPSTYLE } from '../../../../config'
import EstimateEventHistoryLegend from './EstimateEventHistoryLegend'
import EstimateEventHistoryController from './EstimateEventHistoryController'

export { default } from './EstimateEventHistory'

export const EstimateEventHistoryMapConfig = {
  Content: EstimateEventHistoryLegend,
  Controller: EstimateEventHistoryController,
}
